<template>
  <div>
      <template>
        <el-form :inline="true" :model="form" class="search-form-inline">
          <el-form-item>
            <el-input
              v-model="form.keyword"
              placeholder="请输入关键字"
              @keydown.enter.native="onSearch"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="add">新建</el-button>
          </el-form-item>
        </el-form>
      </template>
      <div class="table-class-name">
        <el-table
          :data="tabs[0].tableData"
          style="width: 100%"
          :key="activeName"
          header-row-class-name="table-header-class-name"
          row-class-name="table-row-class-name"
          size="medium"
        >
          <el-table-column prop="projectCode" label="项目编号" width="200"> </el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="350"> </el-table-column>
          <el-table-column prop="province" label="所在省市">
            <template slot-scope="scope">
              {{ getLocationName(scope.row) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="city2" label="创建人" >
          </el-table-column> -->
          <el-table-column prop="createTime" label="创建时间" width="200"> </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <!-- todo: 方便联调，临时去掉状态限制 -->
              <!-- <template v-if="scope.row.state == 4 || scope.row.state == 3"> -->
              <el-button @click="goToProject(scope.row)" type="text" size="small"
                >进入项目</el-button
              >

              <template v-if="scope.row.state == 1 || scope.row.state == 2">
                <el-button
                  type="text"
                  size="small"
                  @click="edit(scope.row)"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="deleteProject(scope.row)"
                  >删除</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-class-name">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="10"
          :page-count="10"
          :current-page="page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
     </div>
    <AddPlanModal
      :visible="planModalVisible"
      @close="closeAddPlanModal"
      @saveBack="getData"
      :record="curRecord"
      :regionList="regionList"
      :projectType="type"
      v-if="planModalVisible"
    />
  </div>
</template>
<script>
import AddPlanModal from './addPlanModal.vue';
import {
  getProjectList,
  deleteProjectApi,
  updateProjectState,
} from './service';
import to from 'await-to-js';
import { mapGetters, mapState } from 'vuex';
export default {
  components: {
    AddPlanModal,
  },
  data() {
    return {
      activeName: 'project-list',
      tabs: [
        {
          name: '规划',
          value: 'project-list',
          type: 1,
          tableData: []
        }
      ],
      form: {
        keyword: '',
      },
      tableData: [],
      planModalVisible: false,
      curRecord: {},
      type: 1,
      total: 0,
      page: 1,
    };
  },
  mounted() {
    this.type = this.$route.query.type || 1;
    this.activeName =  this.tabs.filter(i => i.type == this.type)[0].value;
    this.getData(this.type, null);
    // this.getData(2, null);
    this.$store.dispatch('getRegionList');
  },

  computed: {
    ...mapState(['rawRegionList']),
    ...mapGetters(['regionList']),
    ...mapState(['user']),
  },
  watch: {
    // user
  },
  methods: {
    handleCurrentChange(number) {
      this.getData(this.type, this.form.keyword, number);
    },
    async getData(type, searchKey, pageNo = 1) {
      const curTab = this.tabs.find((v) => v.value === this.activeName);
      type = type || this.type;

      const [err, result] = await to(
        getProjectList({
          searchKey: searchKey || this.form.keyword,
          type,
          pageNo,
        })
      );
      if (!err) {
        curTab.tableData = result?.data?.projectList.records || [];
        this.total = result?.data?.projectList.total;
        this.page = result?.data?.projectList.current;
      }
    },
    handleClick() {
      const curTab = this.tabs.find((v) => v.value === this.activeName);
      this.type = curTab.type;
      this.getData();
    },
    goToProject(record) {
      const query = {
        projectId: record.projectId,
        projectName: record.projectName,
      };
      this.$router.push({
        path: `/${this.activeName}`,
        query: query,
      });
    },
    goTo3D(record, activeName) {
      const nameMap = {
        'project-list': 'planning'
      };
      this.$router.push({
        path: `/3d/preview/${nameMap[activeName]}`,
        query: {
          projectId: record.projectId,
          projectName: record.projectName,
        },
      });
    },
    closeAddPlanModal() {
      this.planModalVisible = false;
      this.curRecord = {};
    },
    showModal() {
      this.planModalVisible = true;
    },
    add() {
      this.showModal();
      this.curRecord = {};
    },
    edit(record) {
      this.planModalVisible = true;
      this.curRecord = record;
    },
    onSearch() {
      console.log(this.form.keyword, 'regionList');
      this.getData();
    },

    getLocationName(record) {
      const provinceName =
        this.rawRegionList?.find((v) => v.regionId == record?.provinceId)
          ?.regionName || '';
      const cityName =
        this.rawRegionList?.find((v) => v.regionId == record?.cityId)
          ?.regionName || '';
      const countyName =
        this.rawRegionList?.find((v) => v.regionId == record?.countyId)
          ?.regionName || '';
      return `${provinceName}${cityName}${countyName}`;
    },
    deleteProject(record) {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err] = await to(
            deleteProjectApi({ projectId: record.projectId })
          );
          if (!err) {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.getData();
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!',
            });
          }
        })
        .catch(() => {});
    },
    updateProjectStateMethod(record) {
      this.$confirm('确认提交审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, result] = await to(
            updateProjectState({ projectId: record.projectId, state: 3 })
          );
          if (!err) {
            this.$message({
              type: 'success',
              message: result.message,
            });
            this.getData();
          } else {
            this.$message({
              type: 'error',
              message: result.message || '提交失败',
            });
          }
        })
        .catch(() => {});
    },
  },
};
</script>
